
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { Session } from "@supabase/auth-helpers-react";

interface BraceletAlertsProps {
  error: string | null;
  success: string | null;
  session: Session | null;
}

export function BraceletAlerts({ error, success, session }: BraceletAlertsProps) {
  // Only show error alerts, no success alerts (as requested)
  if (!error) return null;

  return (
    <Alert variant="destructive" className="fixed top-4 left-4 right-4 max-w-md mx-auto bg-white/10 backdrop-blur border-red-400/50 z-50">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
}
